

import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
    components: {}
})
export default class DateField extends Vue {

    @Prop() date: string;
    @Prop() placeholder: string;
    menuValue = false;
    value = '';
    datePickerValue = '';

    created() {
        this.value = this.parseDate(this.date);
    }

    @Watch("date", {deep: true})
    changeDisplayValue() {
        this.value = this.parseDate(this.date);
    }

    parseDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}-${month.padStart(2, '0')}-${year.padStart(2, '0')}`;
    }

}
